import React, { useEffect, useRef, useState } from "react";
import HeaderTwo from "../components/HeaderTwo";
import HeroOne from "../components/HeroOne";
import CounterOne from "../components/CounterOne";
import AboutOne from "../components/AboutOne";
import ClientAreaFour from "../components/ClientAreaFour";
import ClientAreaOne from "../components/ClientAreaOne";
import SubscribeOne from "../components/SubscribeOne";
import FooterAreaTwo from "../components/FooterAreaTwo";
import Preloader from "../helper/Preloader";
import { Helmet, HelmetProvider } from "react-helmet-async";

const HomePageOne = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [socialMedia, setSocialMedia] = useState(null);
  const [sectionone, setSectionOne] = useState(null);
  const [sectiontwo, setSectionTwo] = useState(null);
  const [sectionThree, setSectionThree] = useState(null);
  const [sectionSix, setSectionSix] = useState(null);
  const [services, setServices] = useState(null);
  const [aboutUs, setAboutUs] = useState(null);
  const [makes, setMakes] = useState(null);
  const [quoteSection, setQuoteSection] = useState(null);
  const [questions, setQuestions] = useState(null);
  const [logo, setLogo] = useState(null);
  const [error, setError] = useState(null);

  const clientAreaRef = useRef(null);
  const scrollToClientArea = () => {
    clientAreaRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://cms.roadrunnertowingmi.com/data/get-home-data"
        );
        const result = await response.json();

        if (response.status === 200) {
          setStats(result.company_settings);
          setSocialMedia(result.social_media_settings);
          setLogo(result.logo);
          setSectionOne(result.sectionone);
          setSectionTwo(result.sectiontwo);
          setServices(result.services);
          setSectionThree(result.sectionthree);
          setSectionSix(result.sectionsix);
          setAboutUs(result.about_us);
          setQuoteSection(result.quoteSection);
          setQuestions(result.questions_sections);
          setMakes(result.makes);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  if (loading) {
    return <Preloader />;
  }
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>
            We pay for your junk cars - Remove your junk cars and get cash on
            the spot.
          </title>
          <meta
            name="description"
            content="Turn your unwanted car into quick cash today! ..."
          />
          <meta
            name="keywords"
            content="cars, junk cars, digital marketing, Yii, React"
          />
          <meta property="og:title" content="My Website - Best Services" />
          <meta
            property="og:description"
            content="Turn your unwanted car into quick cash today! ..."
          />
          <meta
            property="og:url"
            content="https://www.roadrunnertowingmi.com/"
          />
        </Helmet>
        {/* Other components */}
      </HelmetProvider>
      {/* Display error message if API call fails */}
      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}

      {/* Header */}
      <HeaderTwo
        email={stats?.email}
        phone={stats?.phone}
        socials={socialMedia}
        workinghours={stats?.working_hours_text}
      />
      {/* <HeaderOne /> */}

      {/* Hero Section */}
      <HeroOne
        companyName={stats?.name}
        phone={stats?.phone}
        data={sectionone}
        onButtonClick={scrollToClientArea}
        logo={logo}
      />

      {/* Counter Section */}
      <CounterOne phone={stats?.phone} data={sectiontwo} services={services} />

      {/* Client Areas */}
      <ClientAreaFour data={sectionThree} />
      <div ref={clientAreaRef}>
        <ClientAreaOne
          data={quoteSection}
          questions={questions}
          carMakes={makes}
        />
      </div>
      {/* About Section */}
      <AboutOne services={services} data={aboutUs} />
      <ClientAreaFour data={sectionSix} />

      {/* Subscribe Section */}
      <SubscribeOne
        phone={stats?.phone}
        email={stats?.email}
        socials={socialMedia}
        logo={logo}
      />

      {/* Footer */}
      <FooterAreaTwo
        email={stats?.email}
        socials={socialMedia}
        phone={stats?.phone}
        address={stats?.address}
        about_us={stats?.about_us}
      />
    </>
  );
};

export default HomePageOne;
